import React from 'react';
export function Footer() {
  return <footer className="border-t border-steel/15 bg-carbon px-3 py-3 text-center sm:px-6" data-id="element-69" data-mp="32wd2qgad7ltj">
      <p className="text-[0.66rem] font-semibold text-white/85 sm:text-[0.76rem]" data-id="element-70" data-mp="3ggty8ibanj58">
        © 2026 GENERATOR DIAGNOSTIC PRO™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-1 max-w-2xl text-[0.62rem] leading-[1.45] text-steel sm:text-[0.72rem]" data-id="element-71" data-mp="36p6aoshuym91">
        GENERATOR DIAGNOSTIC PRO™ is an educational and professional reference resource. It does not
        replace manufacturer service manuals, model-specific diagnostic procedures, electrical safety
        requirements, applicable regulations, required qualifications, professional training, or
        qualified technical judgment.
      </p>
      <p className="mt-1 text-[0.62rem] text-steel sm:text-[0.72rem]" data-id="element-72" data-mp="3qblwlocpaa12">
        <a href="#" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-73" data-mp="29y5gjzn2fiuh">
          Terms &amp; Conditions
        </a>{' '}
        •{' '}
        <a href="#" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-74" data-mp="3l9k5dbpy7lcr">
          Privacy Policy
        </a>{' '}
        •{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-75" data-mp="3gbimorwfpo1t">
          Contact
        </a>
      </p>
      <p className="mt-0.5 text-[0.62rem] text-steel sm:text-[0.72rem]" data-id="element-76" data-mp="3q8mz400ha55f">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-77" data-mp="830jvkr3s91j">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}